<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 15:37:22
-->
<template>
  <div class="list">
    <div class="commonbox">
      <div class="w1200">
        <breadcrumb :datarow='breadcrumbObj' :islist='false' :detailname='detailInfo.trainTeaching.teachingName'></breadcrumb>
      </div>
    </div>
    <!-- <div class="banner" :style="{'background':'url('+ minioUrl+detailInfo.trainTeaching.teachingBgcUrl+')'}">
      <div class="w1200">
        <div class="info-wrap">
          <div class="title-box">
            <h1>
              {{detailInfo.trainTeaching.teachingName}}
            </h1>
          </div>
        </div>
        <div class="fixed-wrap">
          <div style="padding: 40px">
            <div class="price red">{{detailInfo.trainTeaching.teachingPrice?'¥'+detailInfo.trainTeaching.teachingPrice:'免费'}}</div>
            <div class="count">
              <span>综合评分：<b>{{detailInfo.trainTeaching.teachingCommentRatio||'无评价'}}</b></span>
              <span>进度：<el-progress style="width:300px;display:inline-block"  :stroke-width="20" :percentage="detailInfo.teachRate"></el-progress></span>
            </div>
          </div>
          <div class="buybtn" @click="addCourse" v-if="!detailInfo.isJoinCourse"><i v-if="addload" class="el-icon-loading"></i> 加入课程</div>
          <div class="buybtn buybtned" v-else>已加入课程</div>
        </div>
      </div>
    </div> -->
    <div class="coursediv">
      <img :src="minioUrl+detailInfo.trainTeaching.teachingBgcUrl" class="courseimg">
      <div class="courseright">
        <h1>
          {{detailInfo.trainTeaching.teachingName}}
        </h1>
        <div>
          <div class="count">
            <span>{{detailInfo.trainTeaching.teachingStudyNumber}} 人学习</span>
            <span> 丨 </span>
            <span>综合评分：{{detailInfo.trainTeaching.teachingCommentRatio||'无评价'}}</span>
          </div>
          <div class="count"><span>
              <font style="padding-right:4px">课程进度</font>
              <el-progress style="width:300px;display:inline-block" :stroke-width="20" :percentage="detailInfo.teachRate"></el-progress>
            </span></div>
          <div>
            <div class="price red">{{detailInfo.trainTeaching.teachingPrice?'¥'+detailInfo.trainTeaching.teachingPrice:'免费'}}</div>
            <el-button type="danger" @click="addCourse" v-if="!detailInfo.isJoinCourse" :loading='addload' class="buybtn" round>加入课程</el-button>
            <!-- <div class="buybtn" @click="addCourse" v-if="!detailInfo.isJoinCourse"><i v-if="addload" class="el-icon-loading"></i> 加入课程</div> -->
            <div class="buybtn buybtned" v-else>已加入课程</div>
            <div style="clear:both"></div>
          </div>
          <div>
            <el-button type="success" size="mini" icon="el-icon-chat-dot-round" @click="zjHandle(1)" plain>咨询课程</el-button>
            <el-button type="warning" size="mini" icon="el-icon-warning-outline" @click="zjHandle(2)" plain>举报课程</el-button>
          </div>
          <div class="file" v-if="fileList.length">
            <span>下载附件:</span>
            <div>
              <template v-for="(item,index) in fileList" >
                <el-button :key="index" type="success" size="mini" @click="download(item)" plain>{{item.sourceFileName}}</el-button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div style="clear:both"></div>
    </div>
    <div class="commonbox" style="padding-top: 30px;min-height:53vh;">
      <div class="w1200" style="overflow: hidden">
        <!-- 左树 -->
        <div class="leftinfo">
          <div class="flsxname">{{detailInfo.deptInfo.orgName}}</div>
          <ul class="info">
            <li v-if="detailInfo.deptInfo.orgLogo"><img :src="minioUrl+detailInfo.deptInfo.orgLogo" width="100%"></li>
            <li><span>发布课程数：</span><span>{{detailInfo.deptInfo.uploadCourseNum}}</span></li>
            <!-- <li><span>公司名称：</span><span>{{detailInfo.deptInfo.orgName}}</span></li> -->
            <!-- <li><span>公司地址：</span><span>{{detailInfo.deptInfo.companyAddress}}</span></li> -->
            <li><span>{{detailInfo.deptInfo.companyIntroduction}}</span></li>
            <li><span>联系电话：</span><span>{{detailInfo.deptInfo.contactTel}}</span></li>
          </ul>
        </div>
        <div class="rightinfo">
          <el-tabs v-model="activeName" type="card" @tab-click='changeTab'>
            <el-tab-pane label="课程详情" name="first">
              <div v-html="detailInfo.trainTeaching.teachingDesc"></div>
            </el-tab-pane>
            <el-tab-pane label="章节课程" name="second">
              <ul class="kczj">
                <li v-for="(item) in courseList" :key="item.id">
                  <div class="name">
                    <i class="el-icon-video-play"></i><span>{{item.teachingTitle}} <el-tag style="margin-left:20px" v-if="item.isComplete==1" size="small" effect="plain" type="success">已完成</el-tag>
                      </span>
                  </div>
                  <div class="see" @click="seevideo(item,true)">观 看</div> <!-- 之前是false-->
                  <!-- <div class="see" @click="seevideo(item,true)" style="background:#58b57c" v-if="!detailInfo.isJoinCourse&&index==0">试看3分钟</div> -->
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="课程评价" name="third">
              <div class="evaluationdiv">
                <el-alert :title="'综合评价分：'+(!detailInfo.trainTeaching.teachingCommentRatio?'无评价':detailInfo.trainTeaching.teachingCommentRatio)" type="success" :closable="false"></el-alert>
                <el-button type="success" size="mini" round @click="evaluation">评价课程</el-button>
              </div>
              <ul class="evaluationul">
                <li v-for="item in evaluationList" :key="item.id">
                  <div>
                    <el-rate v-model="item.commentScore" disabled></el-rate>
                    <div><span>{{item.showUser}}</span><span style="padding-left:30px">{{item.createDate}}</span></div>
                  </div>
                  <!-- <div style="padding-top:10px">{{item.typeName}}</div> -->
                </li>
              </ul>
              <div class="pagination">
                <el-pagination background :current-page="ePage" :page-size=10 layout="total,prev, pager, next" :total="eTotal" @current-change="pageCurrentChangeHandle"></el-pagination>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="考试" name="four">
              <ul class="kczj">
                <li @click="examClick(1)">
                  <div class="name">
                    <i class="el-icon-edit-outline"></i><span>模拟考试</span>
                  </div>
                  <div class="see">开 始</div>
                </li>
                <li @click="examClick(2)">
                  <div class="name">
                    <i class="el-icon-edit-outline"></i>
                    <span>正式考试</span>
                    <span style="color:red;margin-left:50px;">正式考试有三次机会，若考试未通过，需等一周后，再进行下次考试</span>
                  </div>
                  <div class="see">开 始</div>
                </li>
              </ul>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 点评 -->
    <el-dialog title="评价课程" :visible.sync="dialogVisible" width="40%" :close-on-click-modal='false'>
      <div style="padding:10px 0 20px 0">
        <el-rate v-model="eForm.commentScore" show-text></el-rate>
      </div>
      <!-- <el-input type="textarea" :rows="6" maxlength="255" show-word-limit placeholder="请您输入评价课程" v-model="eForm.typeName"></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading='btnload' @click="evaluationSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 咨询举报 -->
    <el-dialog :title="diatitle" :visible.sync="zjVisible" width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-input type="textarea" :rows="6" maxlength="255" show-word-limit placeholder="请您输入内容" v-model.trim="questionContent"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zjVisible = false">取 消</el-button>
        <el-button type="primary" :loading='zjnload' @click="zjSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import mixins from '@/mixins/index'
export default {
  name: 'list',
  mixins: [mixins],
  data () {
    return {
      diatitle: '',
      zjVisible: false,
      zjnload: false,
      dialogVisible: false,
      activeName: 'second',
      breadcrumbObj: {},
      selectId: '',
      tid: '',
      minioUrl: '',
      user: '',
      value: '2',
      detailInfo: {},
      courseList: [],
      fileList: [],
      addload: false,
      btnload: false,
      eForm: {
        typeName: '',
        commentScore: ''
      },
      eTotal: 0,
      ePage: 1,
      evaluationList: [],
      questionContent: ''
    }
  },
  components: { breadcrumb },
  mounted () {
    this.activeName = 'second'
  },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/detail') {
          this.minioUrl = process.env.VUE_APP_minio
          this.leftnavarr = JSON.parse(localStorage.getItem('leftnavarr'))
          this.selectId = this.$route.query.selectId || ''
          this.tid = this.$route.query.tid || ''
          this.tName = this.$route.query.tName || ''
          this.breadcrumbObj = this.familyTree(
            this.leftnavarr,
            this.selectId
          )[0]
          // 路由背景更改
          if (this.$store.state.navIndex < 0) {
            if (this.breadcrumbObj.pids.split(',')[0] === '0') {
              this.leftnavarr.forEach((item, index) => {
                if (item.id === this.breadcrumbObj.id) {
                  this.$store.dispatch('setNavIndex', index)
                }
              })
            } else {
              this.leftnavarr.forEach((item, index) => {
                if (item.id === this.breadcrumbObj.pids.split(',')[0]) {
                  this.$store.dispatch('setNavIndex', index)
                }
              })
            }
          }
          this.user = JSON.parse(localStorage.getItem('user')) || ''
          this.getInfo()
          this.getCourse()
          this.getFile()
        }
      },
      immediate: true
    }
  },
  methods: {
    download (item) {
      // window.open('http://131.2.101.103:9000/' + item.path)
      window.open(process.env.VUE_APP_minio + item.path)
    },
    changeTab () {
      if (this.activeName === 'third') {
        this.getEvaluation()
      }
    },
    getInfo () {
      this.$get('/clientNotAuth/getCourseInfo', {
        id: this.tid,
        userId: this.user.id
      }).then((res) => {
        if (res.code === 0) {
          this.detailInfo = res.data
          this.$store.dispatch('setIsAddCourse', res.data.isJoinCourse)
        }
      })
    },
    getCourse () {
      this.$get('/clientNotAuth/getCourseChaptersInfo', {
        id: this.tid,
        userId: this.user.id
      }).then((res) => {
        if (res.code === 0) {
          this.courseList = res.data
        }
      })
    },
    getFile () {
      this.$get('/clientNotAuth/getTeachingFile/' + this.tid + '/3').then((res) => {
        if (res.code === 0) {
          this.fileList = res.data
        }
      })
    },
    addCourse () {
      this.addload = true
      this.$post('/client/personalCenter/joinCourse', {
        teachingId: this.tid
      }).then((res) => {
        this.addload = false
        if (res.code === 0) {
          this.$message.success('加入成功！')
          this.getInfo()
        }
      })
    },
    seevideo (item, isproved) {
      if (isproved) {
        // 试看
        this.$router.push({
          path: '/video',
          query: {
            vurl: process.env.VUE_APP_alioss + item.teachingUrl,
            tid: this.tid,
            title: item.teachingTitle,
            selectId: this.selectId,
            id: item.id,
            tName: this.tName
          }
        })
      } else {
        this.$get('/client/personalCenter/videoPlaybackVerify/' + this.tid).then(
          (res) => {
            if (res.code === 0) {
              this.$router.push({
                path: '/video',
                query: {
                  vurl: process.env.VUE_APP_alioss + item.teachingUrl,
                  tid: this.tid,
                  title: item.teachingTitle,
                  selectId: this.selectId,
                  id: item.id,
                  tName: this.tName
                }
              })
            }
          }
        )
      }
    },
    evaluation () {
      if (!this.detailInfo.isJoinCourse) {
        this.$message.warning('您未加入课程！')
      } else {
        this.btnload = false
        this.eForm.commentScore = ''
        this.eForm.typeName = ''
        this.dialogVisible = true
      }
    },
    getEvaluation () {
      this.$post(
        '/clientNotAuth/teachcomment?teachingId=' +
          this.tid +
          '&page=' +
          this.ePage
      ).then((res) => {
        this.addload = false
        if (res.code === 0) {
          this.evaluationList = res.data.list
          this.eTotal = res.data.total
        }
      })
    },
    pageCurrentChangeHandle (val) {
      this.ePage = val
      this.getEvaluation()
    },
    evaluationSubmit () {
      // if (!this.eForm.typeName) {
      //   this.$message.warning('请您填写评价！')
      // } else
      if (!this.eForm.commentScore) {
        this.$message.warning('请您选择星级！')
      } else {
        this.btnload = true
        this.$post('/client/home/trainteachcomment', {
          ...this.eForm,
          ...{
            userId: this.user.id,
            teachingId: this.tid,
            showUser: this.user.username
          }
        }).then((res) => {
          this.btnload = false
          if (res.code === 0) {
            this.$message.success('点评成功！')
            this.dialogVisible = false
            this.ePage = 1
            this.getEvaluation()
            this.getInfo()
          }
        })
      }
    },
    zjHandle (val) {
      if (!this.detailInfo.isJoinCourse) {
        this.$message.warning('您未加入课程！')
      } else {
        this.questionContent = ''
        this.zjnload = false
        if (val === 1) {
          this.diatitle = '咨询课程'
        } else {
          this.diatitle = '举报课程'
        }
        this.zjVisible = true
      }
    },
    // 举报咨询
    zjSubmit () {
      if (!this.questionContent) {
        this.$message.warning('请您输入内容')
      } else {
        this.zjnload = true
        this.$post('/training/customerService/save ', {
          id: this.tid,
          questionContent: this.questionContent,
          serviceType: this.diatitle === '咨询课程' ? '0' : '1'
        }).then((res) => {
          this.zjVisible = false
          this.zjnload = false
          if (res.code === 0) {
            this.$message.success('提交成功')
          }
        })
      }
    },
    // 正式考试、模拟考试
    examClick (type) {
      let teachingId = this.$route.query.tid
      let tName = this.$route.query.tName
      this.$get('/exam/etuserexamhistory/getIsExam', { teachingId, type }).then(
        (res) => {
          if (res.code !== 0) {
            return false
          }
          // this.pdHaveKt(teachingId, type, tName, res.data)
          let times = res.data
          this.$router.push({
            path: '/exam',
            query: { teachingId, type, tName, times }
          })
        }
      )
    },
    // 判断是否有考题
    pdHaveKt (teachingId, type, tName, times) {
      let obj = { teachingId, type }
      this.$get('/exam/etquestion/getByTeachingId', obj).then((res) => {
        if (res.data.questionList === null) {
          this.$message.error('暂无考题！')
          return false
        }
        this.$router.push({
          path: '/exam',
          query: { teachingId, type, tName, times }
        })
      })
    }
  }
}
</script>
<style scoped>
.w1200 {
  position: relative;
}
.leftinfo {
  border: 1px solid #ddd;
  width: 210px;
  float: left;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.leftinfo .info {
  padding: 0 8px 0 8px;
}
.leftinfo .info > li span {
  flex: 1;
  color: #666;
  font-size: 13px;
}
/* .leftinfo .info>li span:first-child{display: inline-block;width: 72px;flex: none;color: #333;text-align: right;} */
.leftinfo .info > li {
  padding-bottom: 10px;
}
.leftinfo .info > li img {
  width: 100%;
}
/* display: flex;justify-content: space-between; */
.leftinfo .info > li:last-child {
  padding: 0;
}
.flsxname {
  text-align: center;
  font-weight: bold;
  padding: 10px 0;
  background: #eee;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
.banner {
  width: 100%;
  background: url('~@/assets/img/detailbanner.jpg') center center no-repeat;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.banner .info-wrap {
  position: relative;
  padding-top: 72px;
  padding-bottom: 136px;
  text-align: center;
}
.banner .extra {
  position: absolute;
  top: 24px;
  right: 0;
  color: #fff;
  cursor: pointer;
}
.banner .extra * {
  color: #fff;
}
.banner .title-box {
  margin: 0 auto;
  width: 750pt;
}
.banner .title-box h1 {
  color: #fff;
  text-align: center;
  font-weight: normal;
  text-shadow: 0 2px 4px rgba(28, 31, 33, 0.6);
  font-size: 40px;
  line-height: 50px;
}
.banner .title-box h2 {
  margin-top: 8px;
  color: #fff;
  font-weight: normal;
  text-align: center;
  text-shadow: 0 2px 4px rgba(28, 31, 33, 0.6);
  font-size: 18px;
  line-height: 24px;
}
.banner .fixed-wrap {
  position: absolute;
  bottom: -60px;
  left: 0;
  overflow: hidden;
  width: 100%;
  border-radius: 18px;
  height: 160px;
  z-index: 22;
  background: #fff;
  box-shadow: 0 8px 1pc 0 rgba(28, 31, 33, 0.1);
}
.banner .fixed-wrap .price {
  font-size: 30px;
  font-weight: 700;
  padding-bottom: 20px;
}
.banner .fixed-wrap .count span {
  padding-right: 20px;
}
.banner .fixed-wrap .count b {
  color: #67c23a;
  font-weight: 540;
}
.coursediv .count {
  padding-top: 20px;
}
.coursediv .count span {
  padding-right: 10px;
  color: #666;
}
.coursediv .price {
  font-size: 30px;
  font-weight: 700;
  float: left;
  padding-bottom: 20px;
  padding-top: 20px;
}
/* .buybtn {
  position: absolute;
  right: 40px;
  top: 30px;
  font-weight: bold;
  font-size: 16px;
  z-index: 33;
  background: #f01414;
  width: 160px;
  height: 46px;
  line-height: 46px;
  border-radius: 23px;
  text-align: center;
  cursor: pointer;
  display: block;
  color: #fff;
} */
.buybtn {
  position: relative;
  float: right;
  font-weight: bold;
  font-size: 16px;
  background: #f01414;
  width: 160px;
  text-align: center;
  cursor: pointer;
  display: block;
  margin-top: 20px;
  color: #fff;
}
.buybtn.buybtned {
  background: #aaa;
  height: 46px;
  line-height: 46px;
  border-radius: 23px;
}
.buybtn:hover {
  box-shadow: 0 0 15px 8px rgba(28, 31, 33, 0.2);
}
.rightinfo {
  width: 970px;
  float: right;
}
.kczj li {
  height: 60px;
  line-height: 60px;
  background: #ddd;
  margin-bottom: 15px;
  overflow: hidden;
  cursor: pointer;
}
.kczj li:hover {
  background: #ccc;
}
.kczj li .name {
  padding-left: 20px;
  display: flex;
  align-items: center;
  float: left;
}
.kczj li i {
  font-size: 24px;
  margin-right: 5px;
}
.kczj li .see {
  margin-top: 15px;
  margin-right: 20px;
  cursor: pointer;
  float: right;
  background: #f01414;
  width: 100px;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  font-size: 15px;
  color: #fff;
  height: 30px;
}
.evaluationdiv {
  position: relative;
}
.evaluationdiv button {
  position: absolute;
  right: 4px;
  top: 4px;
  z-index: 22;
}
.pagination {
  text-align: right;
}
.evaluationul {
  padding-bottom: 20px;
}
.evaluationul li {
  padding: 15px 10px;
  border-bottom: 1px dashed #ddd;
}
.evaluationul li div {
  display: flex;
  justify-content: space-between;
}
.evaluationul li div span {
  color: #666;
}
div/deep/.el-dialog__body {
  padding: 0 20px;
}
div /deep/.el-rate__icon,
div /deep/.el-rate__text {
  font-size: 24px;
}
.coursediv {
  width: 1200px;
  margin: 0 auto;
  min-height: 320px;
}
.courseimg {
  float: left;
  width: 600px;
  max-height: 400px;
}
.courseright {
  float: right;
  width: 600px;
  padding-left: 30px;
  box-sizing: border-box;
}
.courseright h1 {
  font-size: 32px;
  font-weight: normal;
}
div div /deep/ .el-progress__text {
  margin: 0;
  padding-left: 10px;
  box-sizing: border-box;
  width: 50px;
}
.file{display: flex;margin-top: 15px;}
.file>span{width: 80px;line-height: 28px;}
.file button{margin-bottom: 5px;}
</style>
